import { Client } from '../domain/client';
import { Station } from '../domain/stations';
import { Group, User, UserRole } from '../domain/users';

type AuthData = any;

export const mockClients: readonly Client[] = [
  {
    id: '1',
    name: 'Client 1',
    slug: 'client-1',
    language: 'es-AR',
    logoUrl:
      'https://i0.wp.com/lecturassumergidas.com/wp-content/uploads/2015/03/bbc-logo.png?fit=620%2C444&ssl=1',
  },
];

export const mockStations: readonly Station[] = [
  {
    id: '1',
    name: 'Station 1',
    slug: 'station-1',
    language: 'es-AR',
    timezone: 'America/Buenos_Aires',
    format: 'mp3',
    logoUrl: null,
    streams: [
      {
        main: true,
        url: 'http://stream.live',
      },
    ],
  },
  {
    id: '2',
    name: 'Station 2',
    slug: 'station-2',
    language: 'es-AR',
    timezone: 'America/Buenos_Aires',
    streams: [],
    format: 'mp3',
    logoUrl: 'https://pbs.twimg.com/profile_images/1214587509138743296/MCdWa3TF_400x400.jpg',
  },
  {
    id: '3',
    name: 'Station 3',
    slug: 'station-3',
    language: 'es-ES',
    timezone: '+01:00',
    streams: [],
    format: 'mp3',
    logoUrl: null,
  },
  {
    id: '4',
    name: 'Station 4',
    slug: 'station-4',
    language: 'es-AR',
    timezone: 'America/Buenos_Aires',
    format: 'mpegts',
    logoUrl: null,
    streams: [
      {
        main: true,
        url: 'http://stream.live',
      },
    ],
  },
] as any;

export const mockStationsWithClient: readonly Station[] = [
  {
    id: 'c3-mendoza',
    name: 'Cadena 3 - Mendoza',
    slug: 'c3mendoza',
    language: 'es-AR',
    timezone: 'America/Buenos_Aires',
    client: {
      id: 'cadena3',
      slug: 'cadena3',
      name: 'Cadena 3',
      logoUrl: 'https://pbs.twimg.com/profile_images/1214587509138743296/MCdWa3TF_400x400.jpg',
    },
    streams: [],
    format: 'mp3',
    logoUrl: null,
  },
  {
    id: 'c3-salta',
    name: 'Cadena 3 - Salta',
    slug: 'c3salta',
    language: 'es-AR',
    timezone: 'America/Buenos_Aires',
    client: {
      id: 'cadena3',
      slug: 'cadena3',
      name: 'Cadena 3',
      logoUrl: 'https://pbs.twimg.com/profile_images/1214587509138743296/MCdWa3TF_400x400.jpg',
    },
    streams: [],
    format: 'mp3',
    logoUrl: null,
  },
  {
    id: 'radiorpp',
    name: 'RadioRPP',
    slug: 'radiorpp',
    language: 'es-PE',
    timezone: '-05:00',
    client: {
      id: 'gruporpp',
      slug: 'gruporpp',
      name: 'Grupo RPP',
      logoUrl: 'https://pbs.twimg.com/profile_images/1214587509138743296/MCdWa3TF_400x400.jpg',
    },
    streams: [],
    format: 'mp3',
    logoUrl: null,
  },
] as any;

export const mockUsers: readonly User[] = [
  {
    id: 'user1',
    email: 'user1@mediainbox.io',
    role: UserRole.CLIENT_USER,
    groupId: null,
    name: 'John',
    surname: 'Smith',
  },
  {
    id: 'user2',
    email: 'user2@mediainbox.io',
    role: UserRole.CLIENT_USER,
    groupId: null,
    name: 'Maria',
    surname: 'Johnson',
  },
  {
    id: 'user3',
    email: 'user3@mediainbox.io',
    role: UserRole.CLIENT_USER,
    groupId: null,
    name: '',
    surname: '',
  },
  {
    id: 'user4',
    email: 'user4@mediainbox.io',
    role: UserRole.CLIENT_USER,
    groupId: null,
    name: '',
    surname: '',
  },
  {
    id: 'admin1',
    email: 'admin1@mediainbox.io',
    role: UserRole.CLIENT_ADMIN,
    groupId: null,
    name: 'Alice',
    surname: 'Jones',
  },
];

export const mockGroups: readonly Group[] = [
  {
    id: 'group1',
    name: 'Stations Group A users',
  },
  {
    id: 'group2',
    name: 'Stations Group B users',
  },
];

const mockAuthProviderData = {
  idTokenPayload: {
    name: 'John Smith Long Long Name',
    picture: 'https://s.gravatar.com/avatar/7a6704f71861cfbaaf8a25ee7231a397?s=480',
  },
  accessToken: '',
  expiresIn: 1000,
};

export const mockAuthSuperadmin: AuthData = {
  user: {
    id: '1',
    role: UserRole.SUPERADMIN,
    email: 'admin@mediainbox.io',
    groupId: null,
    providerData: mockAuthProviderData,
    client: null,
  },
};

export const mockAuthAdmin: AuthData = {
  user: {
    id: '2',
    role: UserRole.CLIENT_ADMIN,
    email: 'client_admin@mediainbox.io',
    groupId: null,
    providerData: mockAuthProviderData,
    client: mockClients[0],
  },
};

export const mockAuthUser: AuthData = {
  user: {
    id: '3',
    role: UserRole.CLIENT_USER,
    email: 'client_user@mediainbox.io',
    groupId: null,
    providerData: mockAuthProviderData,
    client: mockClients[0],
  },
};
